import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import {
  Tooltip,
  OverlayTrigger,
  Button as ReactButton,
} from 'react-bootstrap';

import './ProjectDailyReportLog.css';
import printWhiteSvg from 'images/print-white.svg';
import Button from 'components/shared/button/Button';
import PdfViewer from 'components/shared/pdf-viewer/PdfViewer';
import CheckBox from 'components/shared/checkbox/CheckBox';
import { getCurrentProject } from 'components/admin/projects/details/store/selectors';
import { getSettings } from 'components/admin/projects/details/project-settings/store/selectors';
import {
  getDailyReports,
  getShowAddDailyReportModal,
  getDailyReportLogPdf,
  getDailyReportLogPdfViewer,
  getCurrentPage,
  getReportsPageSize,
  getReportsTotal,
  getDailyReportsTabSelected,
  getFieldWorkOrders,
  getShowFieldWorkOrderModal,
} from 'components/admin/projects/details/project-daily-report-log/store/selectors';
import {
  loadSettings,
  updateSettings,
} from 'components/admin/projects/details/project-settings/store/actions';
import {
  loadDailyReportsRequest,
  loadFieldWorkOrdersRequest,
  setShowDailyReportModal,
  loadDailyReportLogPdfRequest,
  setDailyReportLogPdfViewer,
  setDailyReportTab,
} from 'components/admin/projects/details/project-daily-report-log/store/actions';
import DailyReportLogTable from 'components/admin/projects/details/project-daily-report-log/DailyReportLogTable';
import FieldWorkOrderLogTable from 'components/admin/projects/details/project-daily-report-log/FieldWorkOrderLogTable';
import AddDailyReportModal from 'components/admin/projects/details/project-daily-report-log/AddDailyReportModal';
import FieldWorkOrderModal from 'components/admin/projects/details/project-daily-report-log/FieldWorkOrderModal';
import SimplePagination from 'components/shared/pagination/SimplePagination';
import NavigationBar from 'components/shared/navigation/NavigationBar';
import { Enterprise } from 'domain/enterprise';
import { getCurrentUser } from 'selectors/authentication';

const DailyReportTabValue = 1;
const SubDailyReportTabValue = 2;
const FieldWorkOrdersTabValue = 3;

class ProjectDailyReportLog extends Component {
  componentDidMount() {
    const { dispatch, currentProject } = this.props;
    const isSubcontractor = this.subcontractor();
    if (currentProject) {
      this.spackleOrGc() && dispatch(loadSettings(currentProject.id));
      dispatch(loadDailyReportsRequest(currentProject.id, 1, isSubcontractor));
      dispatch(
        setDailyReportTab(
          isSubcontractor ? SubDailyReportTabValue : DailyReportTabValue
        )
      );
    }
  }

  handleOpenReportModal = () => {
    this.props.dispatch(setShowDailyReportModal(true));
  };

  handleLogPdfViewerOpen = () => {
    const { currentProject, dispatch, dailyReportsTabSelected } = this.props;
    dispatch(
      loadDailyReportLogPdfRequest(
        currentProject.id,
        dailyReportsTabSelected === SubDailyReportTabValue
      )
    ).then((response) => {
      if (response.ok) {
        dispatch(setDailyReportLogPdfViewer(true));
      }
    });
  };

  handleLogPdfViewerClose = () => {
    this.props.dispatch(setDailyReportLogPdfViewer(false));
  };

  spackleOrGc = () => {
    const { currentProject } = this.props;
    return (
      currentProject &&
      (Enterprise.spackle(currentProject.contributor_type) ||
        Enterprise.generalContractor(currentProject.contributor_type))
    );
  };

  subcontractor = () => {
    const { currentProject } = this.props;
    return (
      currentProject &&
      Enterprise.subcontractor(currentProject.contributor_type)
    );
  };

  isFieldWorkOrderTab = () => {
    const { dailyReportsTabSelected } = this.props;
    return dailyReportsTabSelected === FieldWorkOrdersTabValue;
  };

  handlePageChange = (newPage) => {
    const { currentProject, dispatch, dailyReportsTabSelected } = this.props;
    if (this.isFieldWorkOrderTab()) {
      dispatch(
        loadFieldWorkOrdersRequest(
          currentProject.id,
          newPage,
          this.spackleOrGc()
        )
      );
    } else {
      dispatch(
        loadDailyReportsRequest(
          currentProject.id,
          newPage,
          SubDailyReportTabValue === dailyReportsTabSelected
        )
      );
    }
  };

  handleDailyReportsTabSelection = (reportTab) => {
    const { dispatch, currentProject } = this.props;
    dispatch(setDailyReportTab(reportTab));
    if (reportTab === FieldWorkOrdersTabValue) {
      dispatch(
        loadFieldWorkOrdersRequest(currentProject.id, 1, this.spackleOrGc())
      );
    } else {
      dispatch(
        loadDailyReportsRequest(
          currentProject.id,
          1,
          SubDailyReportTabValue === reportTab
        )
      );
    }
  };

  buildTabs() {
    const { dailyReportsTabSelected } = this.props;
    let tabs = [
      {
        id: SubDailyReportTabValue,
        title: this.subcontractor() ? 'Daily Reports' : 'Sub Daily Reports',
        class: dailyReportsTabSelected === SubDailyReportTabValue ? 'sel' : '',
      },
      {
        id: FieldWorkOrdersTabValue,
        title: 'Field Work Orders',
        class: this.isFieldWorkOrderTab() ? 'sel' : '',
      },
    ];
    if (this.spackleOrGc()) {
      tabs = [
        {
          id: DailyReportTabValue,
          title: 'Daily Reports',
          class: dailyReportsTabSelected === DailyReportTabValue ? 'sel' : '',
        },
        ...tabs,
      ];
    }
    return tabs;
  }

  handleMultipleFloorsChange = () => {
    const { currentProject, settings, dispatch } = this.props;
    const values = { multipleFloors: !settings.multiple_floors };
    dispatch(updateSettings(currentProject.id, values));
  };

  renderMultipleFloorsTooltip = () => {
    return (
      <Tooltip id="tooltip-multiple-floors">
        Daily Report requires a floor number for each trade
      </Tooltip>
    );
  };

  renderMultipleFloors = () => {
    const { settings } = this.props;
    return (
      <OverlayTrigger
        placement="right"
        overlay={this.renderMultipleFloorsTooltip()}
      >
        <ReactButton className="checkbox-button">
          <CheckBox
            checked={settings.multiple_floors}
            size="medium"
            onChange={this.handleMultipleFloorsChange}
          />
        </ReactButton>
      </OverlayTrigger>
    );
  };

  render() {
    const {
      currentProject,
      dailyReports,
      showAddDailyReportModal,
      dailyReportLogPdf,
      dailyReportLogPdfViewer,
      currentPage,
      reportsPageSize,
      reportsTotal,
      dailyReportsTabSelected,
      fieldWorkOrders,
      showFieldWorkOrderModal,
      settings,
    } = this.props;
    const isSubcontractor = this.subcontractor();
    const showActions =
      isSubcontractor ||
      (this.spackleOrGc() && dailyReportsTabSelected === DailyReportTabValue);
    return (
      currentProject && (
        <div className="daily-report-log">
          {this.spackleOrGc() && settings && (
            <div className="daily-report-multiple-floors">
              <h3>Multiple Floors</h3>
              {this.renderMultipleFloors()}
            </div>
          )}
          <div className="daily-report-log-navigation">
            {isSubcontractor || this.spackleOrGc() ? (
              <NavigationBar
                items={this.buildTabs()}
                onSelected={this.handleDailyReportsTabSelection}
              />
            ) : (
              <h3>Daily Report Log</h3>
            )}
            <div
              className={classnames({
                'buttons-container': true,
                'buttons-container-gc': true,
              })}
            >
              {!this.isFieldWorkOrderTab() && (
                <Button
                  className="button-gray"
                  icon={printWhiteSvg}
                  label="View PDF"
                  onClick={this.handleLogPdfViewerOpen}
                />
              )}
              {showActions && !this.isFieldWorkOrderTab() && (
                <Button
                  className="button-orange"
                  label="Add Daily Report"
                  onClick={this.handleOpenReportModal}
                />
              )}
            </div>
          </div>
          {this.isFieldWorkOrderTab() ? (
            <FieldWorkOrderLogTable
              fieldWorkOrders={fieldWorkOrders}
              isSubcontractor={isSubcontractor}
            />
          ) : (
            <DailyReportLogTable
              dailyReports={dailyReports}
              isSubTabSelected={
                dailyReportsTabSelected === SubDailyReportTabValue
              }
              isSubDailyReport={isSubcontractor}
            />
          )}
          <div className="daily-report-pagination-container">
            <SimplePagination
              currentPage={currentPage}
              pageSize={reportsPageSize}
              total={reportsTotal}
              onPageChange={this.handlePageChange}
            />
          </div>
          {showAddDailyReportModal && (
            <AddDailyReportModal
              projectId={currentProject.id}
              readOnly={!this.spackleOrGc() && !this.subcontractor()}
              show={showAddDailyReportModal}
            />
          )}
          {dailyReportLogPdfViewer && (
            <PdfViewer
              content={{
                source: dailyReportLogPdf,
                type: 'blob',
              }}
              show={dailyReportLogPdfViewer}
              onClose={this.handleLogPdfViewerClose}
            />
          )}
          {showFieldWorkOrderModal && <FieldWorkOrderModal />}
        </div>
      )
    );
  }
}

export default connect((state) => {
  return {
    currentProject: getCurrentProject(state),
    settings: getSettings(state),
    dailyReports: getDailyReports(state),
    showAddDailyReportModal: getShowAddDailyReportModal(state),
    currentUser: getCurrentUser(state),
    dailyReportLogPdf: getDailyReportLogPdf(state),
    dailyReportLogPdfViewer: getDailyReportLogPdfViewer(state),
    currentPage: getCurrentPage(state),
    reportsPageSize: getReportsPageSize(state),
    reportsTotal: getReportsTotal(state),
    dailyReportsTabSelected: getDailyReportsTabSelected(state),
    fieldWorkOrders: getFieldWorkOrders(state),
    showFieldWorkOrderModal: getShowFieldWorkOrderModal(state),
  };
})(ProjectDailyReportLog);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-daily-report-log/ProjectDailyReportLog.js